import {gql} from '@apollo/client'

export const CREATE_FULFILLMENT = gql`
  mutation createFulfillment($fulfillment: FulfillmentInput!) {
    createFulfillment(input: {fulfillment: $fulfillment}) {
      clientMutationId
    }
  }
`

export const CREATE_CARRIER_FULFILLMENT = gql`
  mutation carrierFulfillmentCreate(
    $fulfillment: FulfillmentInput!
    $fulfillmentItems: [FulfillmentItemInput]!
  ) {
    carrierFulfillmentCreate(
      input: {fulfillment: $fulfillment, fulfillmentItems: $fulfillmentItems}
    ) {
      status
      errors {
        code
        message
      }
    }
  }
`
